/*
* Contact Map
*/

const MAP_STYLE =
[
  {
    "featureType": "all",
    "elementType": "labels.text",
    "stylers": [
      {
        "color": "#878787"
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f9f5ed"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "all",
    "stylers": [
      {
        "color": "#aee0f4"
      }
    ]
  }
]

$.fn.ContactMap = function() {
  let self = this
  self.map = undefined
  self.marker = undefined

  return function() {
    setTimeout(function() {
      self.map = new google.maps.Map(self.get(0), {
        styles: MAP_STYLE,
        disableDefaultUI: true,
        zoom: $.mlmi.mobile.isMobile ? 14 : 14,
        scrollwheel: false,
        center: {
          lat: 45.4968 - ($.mlmi.mobile.isMobile ? 0.002 : 0.0015),
          lng: -73.62414 + ($.mlmi.mobile.isMobile ? 0 : 0.0025),
        },
      })

      self.marker = new google.maps.Marker({
        position: {
          lat: 45.4968,
          lng: -73.62414,
        },
        icon: {
          url: fondationsaintlo_l10n.language_code == 'en' ? '/img/elements/marker-foundation.svg' : '/img/elements/marker-fondation.svg',
          size: $.mlmi.mobile.isMobile ? new google.maps.Size(92, 100) : new google.maps.Size(127, 138),
          scaledSize: $.mlmi.mobile.isMobile ? new google.maps.Size(92, 100) : new google.maps.Size(127, 138),
          origin: new google.maps.Point(0, 0),
          anchor: $.mlmi.mobile.isMobile ? new google.maps.Point(46, 100) : new google.maps.Point(64, 138),
        },
        map: self.map,
        url: "https://www.google.com/maps/place/Fondation+Tourisme+Jeunesse+-+Youth+Travel+Foundation/@45.4964494,-73.6338844,16z/data=!3m1!5s0x4cc919efca13c011:0xc9f9069bb259f4c9!4m10!1m2!2m1!1sFondation+Saintlo+5450+chem.+de+la+c%C3%B4te+des+neiges+bur.+220+a!3m6!1s0x4cc919ee2c1098ad:0x24a7300445978bf7!8m2!3d45.4968062!4d-73.6241393!15sCj5Gb25kYXRpb24gU2FpbnRsbyA1NDUwIGNoZW0uIGRlIGxhIGPDtHRlIGRlcyBuZWlnZXMgYnVyLiAyMjAgYZIBCmZvdW5kYXRpb27gAQA!16s%2Fg%2F11fz25bcg_",
        title: fondationsaintlo_l10n.GOOGLE_MAPS,
      })

      google.maps.event.addListener(self.marker, 'click', function() {
        window.open(this.url, '_blank')
      })
    }, $.mlmi.mobile.isMobile ? 800 : 0)

    return self
  }()
}
